@if (cta) {
    <div class="cta-wrapper">
        <div class="left">
            <div><div class="picture" [style.background-image]="imgUrl"></div></div>
        </div>
        <div class="right">
            <h3 class="title">{{ cta.headline }}</h3>
            <div class="text">{{ cta.text | truncate: [220, '...'] }}</div>
            <sew-ws-button class="btn" hierarchy="filled">
                <button (click)="btnClicked()">{{ cta.link_text }}</button>
            </sew-ws-button>
        </div>
    </div>
}
